'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fireImpression = exports.sendSetiImpression = exports.getContent = exports.checkForContentDisplayParams = undefined;

var _lodash = require('lodash.get');

var _lodash2 = _interopRequireDefault(_lodash);

var _analytics = require('@pcln/analytics');

var _analytics2 = _interopRequireDefault(_analytics);

var _request = require('@pcln/request');

var _request2 = _interopRequireDefault(_request);

var _urlSearchParamsPolyfill = require('url-search-params-polyfill');

var URLSearchParamPolyfill = _interopRequireWildcard(_urlSearchParamsPolyfill);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var checkForContentDisplayParams = exports.checkForContentDisplayParams = function checkForContentDisplayParams() {
  if (typeof window === 'undefined') {
    return false;
  }

  var urlParams = typeof URLSearchParams === 'function' ? new URLSearchParams(window.location.search) : new URLSearchParamPolyfill(window.location.search);
  return urlParams.has('displayContentIds');
};

var getContent = exports.getContent = function getContent(aceContent, name, fallback) {
  var showContentIds = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  if (showContentIds && (name || fallback)) {
    var content = (0, _lodash2.default)(aceContent, name, fallback);
    return name + ': ' + (content && content.value ? content.value : content);
  }
  return (0, _lodash2.default)(aceContent, name, fallback);
};

/* TODO: PCLN Experimentation does not support the firing of just a seti test name so, this utilitily function was created in place of it.
*  Consider exposing a function in PCLN Experimentation that does just this....
*/
var sendSetiImpression = exports.sendSetiImpression = function sendSetiImpression(_ref) {
  var experimentName = _ref.experimentName,
      clientGUID = _ref.clientGUID,
      productID = _ref.productID;

  var setiEvents = [{ experimentTagName: experimentName }];
  var data = { productID: productID, setiEvents: setiEvents };
  return new Promise(function (resolve, reject) {
    (0, _request2.default)('ace', '/impression/' + clientGUID).setConfig({
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        Accept: 'application/json'
      },
      method: 'POST',
      json: data
    }).execute(function (err, res, body) {
      if (err) {
        reject(err);
      } else if (!res || res.statusCode !== 200) {
        reject(new Error('Server returned invalid response', 'Response code of ' + res.statusCode));
      }

      resolve(body);
    });
  });
};

var fireImpression = exports.fireImpression = function fireImpression() {
  var ace = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var name = arguments[1];
  var experiments = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  var content = getContent(ace.content, name);

  if (typeof window === 'undefined') {
    return;
  }

  var bootstrapData = window.PCLN_BOOTSTRAP_DATA || {};

  var _ref2 = bootstrapData.tmsConfig || {},
      _ref2$productID = _ref2.productID,
      productID = _ref2$productID === undefined ? 0 : _ref2$productID;

  var _ref3 = bootstrapData.webstats || {},
      _ref3$clientGUID = _ref3.clientGUID,
      clientGUID = _ref3$clientGUID === undefined ? null : _ref3$clientGUID;

  if (content && content.makeImpressionCall && content.experimentName) {
    /*
     TODO: would be nice to fire these impressions when the browser is idle - IUU improvement
     */
    sendSetiImpression({ experimentName: content.experimentName, clientGUID: clientGUID, productID: productID }).then(function () {
      return true;
    }).catch(function (e) {
      _analytics2.default.logError({ name: 'Ace Content: Client Impression Error', message: e, severity: 1 });
    });
  } else {
    experiments.forEach(function (experiment) {
      return sendSetiImpression({
        experimentName: experiment,
        clientGUID: clientGUID,
        productID: productID
      }).then(function () {
        return true;
      }).catch(function (e) {
        _analytics2.default.logError({ name: 'Ace Content: Client Impression Error', message: e, severity: 1 });
      });
    });
  }
};